export default function convertProductRatio(images) {
    if (images) {
        for (let i = 0; i < images.length; i++) {
            images[i].style.height = images[i].clientWidth + 'px';
        }
    }
};
